<div class="OutsideContainer Flexbox Flexbox--column" #Container>
  <div class="Container Grid Gap--smaller">
    <mat-card *ngFor="let size of sizesToShow()" #SizeCard [class.Selected]="selectedSize()?.id === size.id" [class.Unavailable]="!reachableSizes().includes(size.id)">
      <mat-card-content>
        <button mat-flat-button (click)="sizeClick(size)">
          <div class="Flexbox Align--center Justify--center ButtonContent">
            <span>{{ size.displayName }}</span>
            <!-- <app-selection-indicator [isVisible]="selectedSize() === size" [shouldAnimate]="shouldAnimateSelection"></app-selection-indicator> -->
          </div>
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>